<template>
  <div class="whom__wrapper">
    <div class="whom__container">
      <div class="whom__info">
        <p class="whom__info-subtitle">кастинг</p>
        <h2 class="whom__info-title">
          Кого шукаємо→ саме тебе. Нові обличчя будь-якої зовнішності, статі та
          віку.
        </h2>
        <h2 class="whom__info-title-thin">Ми відкриті для всіх.</h2>
      </div>
      <div class="whom__content">
        <div class="whom__content-left">
          <div class="div whom__content-left-text">
            Зріст, вага, тату, пірсинг, колір шкіри чи волосся — усе це частина
            тебе. Краса — у деталях, у твоїй неповторності та сміливості бути
            собою.
          </div>
          <div class="div whom__content-left-text">
            Немає досвіду? Круто! У рекламі це взагалі не проблема. Навіть якщо
            ти соромливий – навчимо не боятися камери та режисера.
          </div>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeqH_MlJWDVN0OUicbCBT2CMPqYCCc5VqSzXFQw7Eds39FHWQ/viewform"
          >
            <div class="whom__content-left-button">Записатися на проби</div>
          </a>
        </div>
        <div class="whom__content-right">
          <video
            class="whom__content-right-video"
            src="/static/video/hero-video.mp4"
            autoplay
            muted
            playsinline
            loop
            alt="Альт-текст інтро зображення"
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "whom-block",
}
</script>

<style lang="scss">
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Light.woff2") format("woff2");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.whom {
  &__wrapper {
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
  }

  &__container {
    padding: 0 74px 160px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 60px;

    &-subtitle {
      font-size: 14px;
      font-weight: 500;
      padding-bottom: 20px;
      text-transform: uppercase;
    }

    &-title {
      font-size: 60px;
      line-height: 60px;
      font-weight: 500;
      color: #000000;
      letter-spacing: -0.02em;
      text-align: center;
      max-width: 845px;
      font-family: "Inter", sans-serif;

      &-thin {
        font-family: "Nyght Serif";

        font-size: 60px;
        line-height: 60px;
        font-weight: 300;
        text-align: center;
        max-width: 845px;
      }
    }
  }

  &__content {
    border-bottom: 1px solid #0000004d;
    border-top: 1px solid #0000004d;
    height: 700px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: stretch;

    &-left {
      padding-top: 60px;
      display: flex;
      flex-direction: column;
      row-gap: 30px;

      &-text {
        max-width: 519px;
        font-size: 20px;
        font-family: "Inter", sans-serif;
      }

      &-button {
        background-color: #fcc10f;

        display: flex;
        justify-content: center;
        align-items: center;

        width: 222px;
        height: 40px;
        font-family: "Inter", sans-serif;

        font-size: 14px;
        color: #000000;
        border-radius: 8px;
        text-transform: uppercase;
        font-weight: 600;
      }
    }

    &-right {
      width: 100%;
      height: 100%;
      &-video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

@media (max-width: 998px) {
  .whom {
    &__content {
      height: 500px;
    }

    &__container {
      padding: 0 24px 116px;
    }
  }
}

@media (max-width: 682px) {
  .whom {
    &__info {
      padding-bottom: 32px;
      &-title {
        font-size: 36px;
        line-height: 36px;

        &-thin {
          font-size: 36px;
          line-height: 36px;
        }
      }
    }

    &__content {
      display: flex;
      flex-direction: column-reverse;
      height: 100%;
      padding: 32px 0;
      &-left {
        &-text {
          font-size: 16px;
          font-family: "Inter", sans-serif;
        }
        padding-top: 32px;
      }
      &-right {
        &-video {
          width: 100%;
          height: 364px;
        }
      }
    }
  }

  @media (max-width: 500px) {
    .whom {
      &__content {
        &-left {
          &-button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
